import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { X } from "lucide-react";

// Google Analytics gtag 類型聲明
declare global {
  interface Window {
    gtag?: (
      command: string,
      target: string,
      config?: Record<string, string>
    ) => void;
  }
}

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // 檢查用戶是否已經做出選擇
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    // 更新同意狀態
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    // 保持拒絕狀態（默認已設置為拒絕）
    localStorage.setItem("cookie_consent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom">
      <Card className="max-w-4xl mx-auto p-6 shadow-lg border-2">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-2">Cookie 使用聲明</h3>
            <p className="text-sm text-muted-foreground mb-4">
              我們使用 Cookie 和類似技術來改善您的瀏覽體驗、分析網站流量，並提供個性化內容。
              點擊「接受」即表示您同意我們使用 Cookie。您可以隨時在隱私設置中更改您的偏好。
            </p>
            <div className="flex flex-wrap gap-3">
              <Button onClick={handleAccept} size="sm">
                接受所有 Cookie
              </Button>
              <Button onClick={handleDecline} variant="outline" size="sm">
                僅必要 Cookie
              </Button>
              <Button
                variant="ghost"
                size="sm"
                asChild
              >
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                  了解更多
                </a>
              </Button>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDecline}
            className="flex-shrink-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default CookieConsent;
